import { Component } from "react";
import { createRoot } from "react-dom/client";
import { IAlertProps, AlertDialog } from "./Alert";
import { IConfirmationProps, ConfirmationDialog } from "./Confirmation";
import { warn as warnHelper } from "../Common/Notifications/helper";

enum ModalType {
    Alert,
    Confirmation,
}

interface IProps {}

interface INotifyState {
    title?: string;
    text?: string;
    yesButtonTitle?: string;
    yesButtonCallback?: () => void;
    noButtonTitle?: string;
    noButtonCallback?: () => void;
    open: boolean;
    type: ModalType;
}

// @deprecated Use Snackbar or Confirmation Dialog from Components Library
class Notifier extends Component<IProps, INotifyState> {
    constructor(props) {
        super(props);

        this.state = {
            text: "",
            title: "",
            open: false,
            type: ModalType.Alert,
        };
    }

    // @deprecated Use Snackbar from Components Library
    alert = (text: string, title: string, callback?: () => void) => {
        this.setState({
            text: text,
            title: title,
            open: true,
            yesButtonCallback: callback,
            type: ModalType.Alert,
        });
    };

    // @deprecated Use Confirmation Dialog from Components Library
    confirmYesNo = (text: string, title: string, callbackYes?: () => void, callbackNo?: () => void) => {
        this.setState({
            text: text,
            title: title,
            open: true,
            yesButtonCallback: callbackYes,
            noButtonCallback: callbackNo,
            type: ModalType.Confirmation,
        });
    };

    // @deprecated Use Snackbar from Components Library
    warn = (message: string, title: string) => {
        warnHelper(`${title}: ${message}`);
    };

    onClose = () => {
        this.setState({ open: false });
    };

    render() {
        if (!this.state.open) return null;

        switch (this.state.type) {
            case ModalType.Alert: {
                const props: IAlertProps = {
                    title: this.state.title,
                    text: this.state.text,
                    yesButtonCallback: this.onClose,
                    onModalClosed: this.onClose,
                };

                return <AlertDialog {...props} />;
            }
            case ModalType.Confirmation: {
                const props: IConfirmationProps = {
                    title: this.state.title,
                    text: this.state.text,
                    yesButtonCallback: () => {
                        this.state.yesButtonCallback();
                        this.onClose();
                    },
                    noButtonCallback: this.onClose,
                    onModalClosed: this.onClose,
                };

                return <ConfirmationDialog {...props} />;
            }
        }
    }
}

export const renderNotifier = (mountPoint: string) => {
    return new Promise((resolve, _) => {
        const container = document.getElementById(mountPoint);
        const root = createRoot(container);
        root.render(<Notifier ref={(ref) => resolve(ref)} />);
    });
};
